// Kept apart from `preview_markdown.js`, so that importing the names does not load
// a second copy of its document listeners.
export const MARKDOWN_EVENT_SHOW = 'markdown-preview:show';
export const MARKDOWN_EVENT_HIDE = 'markdown-preview:hide';
export const MARKDOWN_EVENT_TOGGLE = 'markdown-preview:toggle';
